import React from "react";
import { Link } from "react-router-dom";
import "../../services-store.css";
import BrandGraphic from "../BrandGraphic";
import { FiCpu, FiTool, FiSettings, FiKey } from "react-icons/fi";
const serviceIcons = [FiCpu, FiTool, FiSettings, FiKey];

const services = [
  {
    id: "parts",
    title: "Parts & accessories",
    description:
      "Our product range includes gaming boards, touchscreens, LCD monitors, bill acceptors, ticket printers, power supplies, cables, switches, and electronic components. We source parts and accessories from local and international suppliers to support replacement, repair, and assembly projects.",
    note: "Send the model and part number if you need help checking compatibility.",
    link: "/products",
    action: "Browse products",
  },
  {
    id: "maintenance",
    title: "Installation & maintenance",
    description:
      "We help customers with gaming machine installation, fault diagnosis, repairs, and ongoing maintenance. Tell us the machine model, describe the fault, and include any error messages so we can assess the problem and tell you what parts or servicing it may need.",
    note: "We install the machines we lease. Installation for purchased machines is available as a paid service; contact us for details.",
    link: "/contact",
    action: "Request technical support",
  },
  {
    id: "manufacturing",
    title: "Manufacturing & assembly",
    description:
      "We manufacture and assemble gaming machines to meet each customer’s agreed requirements. Start with your preferred machine or game, then discuss the cabinet, monitor, bill acceptor, printer, installation requirements, and additional hardware with our team.",
    note: "Your selected game remains unchanged while we discuss the hardware configuration. Compatibility, the final specification, quantity, installation, and delivery are confirmed in your quotation.",
    link: "/build-your-machine",
    action: "Plan your machine",
  },
  {
    id: "leasing",
    title: "Gaming machine leasing",
    description:
      "Our leasing service is for licensed bars and other eligible operators who want Technogenious gaming machines at their premises. Tell us about your location, available space, and the machines you are interested in so we can suggest a suitable arrangement.",
    note: "Leasing works on a 60/40 profit share: your venue keeps 40% and Technogenious receives 60%. Talk to us about machine availability, installation, and maintenance for your location.",
    link: "/contact",
    action: "Discuss leasing",
  },
];

export default function Service() {
  return (
    <main className="sv-page">
      <section className="sv-hero">
        <div className="sv-wrap company-hero-grid"><div className="company-hero-copy">
          <p className="sv-eyebrow">TECHNOGENIOUS SERVICES</p>
          <h1>
            Support for your gaming machine.
            <br />
            <span>From parts to setup.</span>
          </h1>
          <p>
            Find the right component, plan an installation, or get help with a technical issue. Our Kingston team is here to help you take the
            next step.
          </p>
          <div className="sv-actions">
            <Link className="sv-primary" to="/contact">
              Talk to our team →
            </Link>
            <Link to="/products">Shop parts & accessories</Link>
          </div>
        </div>
          <div className="company-visual company-components"><BrandGraphic /><div className="company-caption"><strong>Parts. Precision. Practical support.</strong><span>Build · Install · Maintain</span></div></div>
        </div>
      </section>
      <div className="sv-wrap sv-content">
        <section className="sv-specialist" aria-labelledby="sv-licensing-title">
          <p className="sv-eyebrow">BGLC LICENSING</p>
          <h2 id="sv-licensing-title">
            Licensed support for your gaming machines
          </h2>
          <p>
            Technogenious Solutions Ltd. is a BGLC-licensed technical service
            provider for gaming machines and related components. We manufacture
            and assemble gaming machines and provide testing, repair, sales,
            supply, and installation services.
          </p>
        </section>
        <section aria-labelledby="sv-options" style={{ marginTop: 40 }}>
          <h2 id="sv-options">How can we help?</h2>
          <p className="sv-intro">
            Choose a service to explore your options or start a conversation.
          </p>
          <div className="sv-grid">
            {services.map((service, index) => (
              <article key={service.id} id={service.id} className="sv-card">
                <div className="service-card-mark" aria-hidden="true">
                  <span className="company-icon">{React.createElement(serviceIcons[index])}</span>
                </div>
                <h3>{service.title}</h3>
                <p>{service.description}</p>
                <p className="sv-note">{service.note}</p>
                <Link to={service.link}>{service.action} →</Link>
              </article>
            ))}
          </div>
        </section>
        <section
          className="sv-specialist"
          aria-labelledby="sv-specialist-title"
        >
          <p className="sv-eyebrow">SPECIALIST COMPONENT SUPPORT</p>
          <h2 id="sv-specialist-title">
            Pyramid bill acceptors & ticket printers
          </h2>
          <p>
            Technogenious Solutions is listed in Pyramid Technologies’
            international distributor and service-centre directory for Jamaica.
            We provide advice on Pyramid products and assist with enquiries about
            bill acceptor repairs and maintenance.
          </p>
          <p>
            For a servicing enquiry, include the product model, serial number if
            available, and a description of the fault. For a replacement or new
            installation, share the machine model and existing connections so
            the team can discuss compatibility before you purchase.
          </p>
          <div className="sv-actions">
            <Link className="sv-primary" to="/contact">
              Discuss Pyramid servicing →
            </Link>
            <a
              href="https://pyramidacceptors.com/contact-usa"
              target="_blank"
              rel="noopener noreferrer"
            >
              Pyramid’s Jamaica listing ↗
            </a>
          </div>
        </section>
        <section className="sv-process" aria-labelledby="sv-process-title">
          <h2 id="sv-process-title">From your enquiry to the right service.</h2>
          <ol>
            <li>
              <strong>Tell us what you need</strong>
              <p>
                Tell us about your machine, the part you need, the fault you are
                experiencing, or your planned project, along with your location.
              </p>
            </li>
            <li>
              <strong>Discuss the details</strong>
              <p>
                Our team reviews your requirements and explains the
                specifications or assessment needed.
              </p>
            </li>
            <li>
              <strong>Agree on the next step</strong>
              <p>
                Confirm the scope, quotation, timing, and installation or
                collection arrangements before proceeding.
              </p>
            </li>
          </ol>
        </section>
        <section className="sv-prepare" aria-labelledby="sv-prepare-title">
          <div>
            <p className="sv-eyebrow">BEFORE YOU GET IN TOUCH</p>
            <h2 id="sv-prepare-title">A little detail goes a long way.</h2>
            <p>
              Help us understand what you need so we can discuss the right
              service and next steps.
            </p>
          </div>
          <ul>
            <li>Your gaming machine brand, model, and part number</li>
            <li>A description of the issue and any error messages</li>
            <li>Clear photos of the gaming machine or component</li>
            <li>Your location and preferred contact details</li>
          </ul>
        </section>
        <section className="sv-next" aria-labelledby="sv-next-title">
          <div>
            <h2 id="sv-next-title">Not sure where to start?</h2>
            <p>
              Tell us what you’re working on. Ask our team to confirm service
              availability, pricing, and timing before making arrangements.
            </p>
          </div>
          <a
            className="sv-primary"
            href="https://wa.me/18764482032?text=Hello%2C%20I%20would%20like%20to%20enquire%20about%20your%20technical%20services."
            target="_blank"
            rel="noopener noreferrer"
          >
            Enquire on WhatsApp ↗
          </a>
        </section>
      </div>
    </main>
  );
}
